export default __webpack_public_path__ + "static/media/lastsamurai.7e59005a.png";